// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ps-page {
    --primary-50: #e9f2ff;
    --primary-300: #7fb7ff;
    --primary-500: #0077d6;
    --primary-700: #035aa6;
    --muted: #6b7280;
    --border: #e4e8f0;

    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
    color: #0b2540;
    line-height: 1.6;
}

.ps-page section {
    padding: 40px 24px;
    margin: 20px 0;
    border-radius: 12px;
}

.ps-section {
    background: #fff;
    border: 1px solid var(--border);
}

.ps-section-alt {
    background: linear-gradient(180deg, var(--primary-50), #f6fbff);
}

/* ---------- Hero ---------- */

.ps-hero {
    background: linear-gradient(90deg, rgba(0, 119, 214, 0.06), rgba(3, 90, 166, 0.04));
    border: 1px solid var(--border);
}

.ps-h1 {
    font-size: 34px;
    line-height: 1.2;
    font-weight: 800;
    letter-spacing: -0.01em;
    max-width: 780px;
    margin-bottom: 16px;
    color: #042a48;
}

.ps-h1 em {
    font-style: normal;
    background: linear-gradient(180deg, transparent 62%, var(--primary-50) 62%);
    color: var(--primary-700);
}

.ps-lead {
    font-size: 15px;
    color: var(--muted);
    max-width: 640px;
    margin-bottom: 28px;
}

.ps-stat-pills {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 32px;
}

.ps-stat-pill {
    display: flex;
    align-items: baseline;
    gap: 8px;
    background: var(--primary-700);
    color: #fff;
    border-radius: 10px;
    padding: 12px 18px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ps-stat-pill:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 24px -10px rgba(3, 90, 166, 0.4);
}

.ps-stat-pill b {
    font-size: 18px;
    font-weight: 800;
}

.ps-stat-pill span {
    font-size: 12px;
    color: #cfe4fb;
}

.ps-stat-pill.alt {
    background: #fff;
    border: 1px solid var(--border);
}

.ps-stat-pill.alt b {
    color: var(--primary-700);
}

.ps-stat-pill.alt span {
    color: var(--muted);
}

/* ---------- Inventory grid ---------- */

.ps-inventory-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 14px;
}

.ps-inventory-card {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 20px 16px;
    transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.ps-inventory-card:hover {
    border-color: var(--primary-500);
    transform: translateY(-4px);
    box-shadow: 0 14px 28px -14px rgba(0, 119, 214, 0.3);
}

.ps-inventory-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: var(--primary-50);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
}

.ps-inventory-icon img {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.ps-inventory-card h4 {
    font-size: 14px;
    font-weight: 700;
    margin: 0 0 6px;
    color: #042a48;
}

.ps-inventory-card p {
    font-size: 12px;
    color: var(--muted);
    margin: 0;
}

/* ---------- Section heads ---------- */

.ps-sec-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 32px;
    margin-bottom: 28px;
    flex-wrap: wrap;
}

.ps-sec-tag {
    display: block;
    font-size: 11px;
    font-weight: 700;
    color: var(--primary-500);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.ps-sec-head h2 {
    font-size: 24px;
    font-weight: 800;
    letter-spacing: -0.01em;
    max-width: 520px;
    margin: 0;
    color: #042a48;
}

.ps-sec-desc {
    font-size: 13px;
    color: var(--muted);
    max-width: 420px;
    margin: 0;
}

.ps-kpi-tag {
    margin-bottom: 12px;
}

/* ---------- Two-column layout ---------- */

.ps-cols {
    display: flex;
    gap: 40px;
    align-items: flex-start;
}

.ps-cols > * {
    flex: 1 1;
    min-width: 0;
}

/* ---------- Platform badges ---------- */

.ps-badge-row,
.ps-logo-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.ps-badge {
    font-size: 12.5px;
    font-weight: 600;
    color: var(--primary-700);
    background: var(--primary-50);
    border-radius: 8px;
    padding: 9px 14px;
    border: 1px solid transparent;
    transition: transform 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.ps-badge:hover {
    transform: translateY(-2px);
    background: var(--primary-500);
    color: #fff;
    box-shadow: 0 10px 18px -8px rgba(0, 119, 214, 0.45);
}

.ps-badge.outline {
    background: transparent;
    border-color: var(--border);
    color: var(--muted);
}

.ps-badge.outline:hover {
    background: var(--primary-700);
    border-color: var(--primary-700);
    color: #fff;
}

/* ---------- KPI cards ---------- */

.ps-kpi-grid {
    display: flex;
    gap: 12px;
}

.ps-kpi-card {
    flex: 1 1;
    min-width: 0;
    border-radius: 12px;
    padding: 20px 18px;
    color: #fff;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ps-kpi-card.c1 { background: var(--primary-700); }
.ps-kpi-card.c2 { background: var(--primary-500); }
.ps-kpi-card.c3 { background: #042a48; }

.ps-kpi-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 30px -12px rgba(3, 90, 166, 0.45);
}

.ps-kpi-card b {
    font-size: 26px;
    font-weight: 800;
    display: block;
}

.ps-kpi-card span {
    font-size: 12px;
    font-weight: 700;
    display: block;
    margin: 4px 0 4px;
}

.ps-kpi-card p {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.75);
    margin: 0;
    line-height: 1.4;
}

/* ---------- Identity spine diagram ---------- */

.ps-spine-wrap {
    position: relative;
    border: 1px solid var(--border);
    border-radius: 12px;
    background: #fff;
    padding: 40px 24px;
}

.ps-spine-track {
    position: absolute;
    left: 5%;
    right: 5%;
    top: 50%;
    height: 2px;
    background: repeating-linear-gradient(90deg, var(--border) 0 8px, transparent 8px 14px);
    transform: translateY(-50%);
    z-index: 0;
}

.ps-node-row {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1;
    flex-wrap: wrap;
    gap: 18px 0;
}

.ps-node {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 13.5%;
    min-width: 100px;
}

.ps-node-dot {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid var(--primary-500);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0 6px #fff;
    padding: 8px;
    box-sizing: border-box;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ps-node:hover .ps-node-dot {
    transform: scale(1.12);
    box-shadow: 0 0 0 6px #fff, 0 12px 22px -8px rgba(0, 119, 214, 0.5);
}

.ps-node-dot img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.ps-node span {
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    color: #042a48;
}

/* ---------- Contextual targeting trio ---------- */

.ps-trio {
    display: flex;
    gap: 14px;
    margin-bottom: 28px;
}

.ps-trio-card {
    flex: 1 1;
    min-width: 0;
    background: var(--primary-700);
    border-radius: 12px;
    padding: 22px 20px;
    color: #fff;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ps-trio-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 30px -12px rgba(3, 90, 166, 0.45);
}

.ps-trio-card h4 {
    font-size: 14.5px;
    font-weight: 700;
    margin: 0 0 8px;
}

.ps-trio-card p {
    font-size: 12px;
    color: #cfe4fb;
    line-height: 1.5;
    margin: 0;
}

/* ---------- Partner panel with logo chips ---------- */

.ps-partner-panel {
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 22px;
    background: #fff;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.ps-partner-panel:hover {
    transform: translateY(-3px);
    border-color: var(--primary-500);
    box-shadow: 0 14px 28px -14px rgba(0, 119, 214, 0.25);
}

.ps-logo-chip {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 6px 14px;
    border: 1px solid var(--border);
    border-radius: 8px;
    background: #fff;
}

.ps-logo-chip img {
    max-height: 100%;
    max-width: 100px;
    object-fit: contain;
}

/* ---------- Precision / safety list ---------- */

.ps-prec-list {
    display: flex;
    flex-direction: column;
}

.ps-prec-item {
    display: flex;
    gap: 16px;
    padding: 16px 12px;
    border-bottom: 1px solid var(--border);
    border-radius: 8px;
    margin: 0 -12px;
    transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.ps-prec-item:last-child {
    border-bottom: none;
}

.ps-prec-item:hover {
    transform: translateX(4px);
    background: var(--primary-50);
}

.ps-prec-icon {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    background: var(--primary-50);
    flex: 0 0 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--primary-500);
    font-size: 15px;
    transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.ps-prec-item:hover .ps-prec-icon {
    background: var(--primary-500);
    color: #fff;
    transform: scale(1.08);
}

.ps-prec-item h4 {
    font-size: 14px;
    font-weight: 700;
    margin: 0 0 3px;
    color: #042a48;
}

.ps-prec-item p {
    font-size: 12.5px;
    color: var(--muted);
    margin: 0;
}

@media (max-width: 980px) {
    .ps-inventory-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .ps-cols {
        flex-direction: column;
    }

    .ps-kpi-grid {
        flex-direction: column;
    }

    .ps-trio {
        flex-direction: column;
    }

    .ps-node-row {
        justify-content: center;
    }

    .ps-node {
        width: 40%;
    }

    .ps-spine-track {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/segments/product-spine/ProductSpine.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;;IAEjB,2FAA2F;IAC3F,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,+DAA+D;AACnE;;AAEA,+BAA+B;;AAE/B;IACI,mFAAmF;IACnF,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,2EAA2E;IAC3E,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yCAAyC;;AAEzC;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,6EAA6E;AACjF;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA,wCAAwC;;AAExC;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4CAA4C;;AAE5C;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA,0CAA0C;;AAE1C;;IAEI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,gGAAgG;AACpG;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,WAAW;AACf;;AAEA,oCAAoC;;AAEpC;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,qDAAqD;AACzD;;AAEA,kBAAkB,8BAA8B,EAAE;AAClD,kBAAkB,8BAA8B,EAAE;AAClD,kBAAkB,mBAAmB,EAAE;;AAEvC;IACI,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,gBAAgB;AACpB;;AAEA,iDAAiD;;AAEjD;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,QAAQ;IACR,WAAW;IACX,uFAAuF;IACvF,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,YAAY;IACZ,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,sBAAsB;IACtB,mEAAmE;AACvE;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,oDAAoD;;AAEpD;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA,wDAAwD;;AAExD;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,6EAA6E;AACjF;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,kDAAkD;;AAElD;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,2EAA2E;AAC/E;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,sEAAsE;AAC1E;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".ps-page {\n    --primary-50: #e9f2ff;\n    --primary-300: #7fb7ff;\n    --primary-500: #0077d6;\n    --primary-700: #035aa6;\n    --muted: #6b7280;\n    --border: #e4e8f0;\n\n    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;\n    color: #0b2540;\n    line-height: 1.6;\n}\n\n.ps-page section {\n    padding: 40px 24px;\n    margin: 20px 0;\n    border-radius: 12px;\n}\n\n.ps-section {\n    background: #fff;\n    border: 1px solid var(--border);\n}\n\n.ps-section-alt {\n    background: linear-gradient(180deg, var(--primary-50), #f6fbff);\n}\n\n/* ---------- Hero ---------- */\n\n.ps-hero {\n    background: linear-gradient(90deg, rgba(0, 119, 214, 0.06), rgba(3, 90, 166, 0.04));\n    border: 1px solid var(--border);\n}\n\n.ps-h1 {\n    font-size: 34px;\n    line-height: 1.2;\n    font-weight: 800;\n    letter-spacing: -0.01em;\n    max-width: 780px;\n    margin-bottom: 16px;\n    color: #042a48;\n}\n\n.ps-h1 em {\n    font-style: normal;\n    background: linear-gradient(180deg, transparent 62%, var(--primary-50) 62%);\n    color: var(--primary-700);\n}\n\n.ps-lead {\n    font-size: 15px;\n    color: var(--muted);\n    max-width: 640px;\n    margin-bottom: 28px;\n}\n\n.ps-stat-pills {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 32px;\n}\n\n.ps-stat-pill {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    background: var(--primary-700);\n    color: #fff;\n    border-radius: 10px;\n    padding: 12px 18px;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.ps-stat-pill:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 12px 24px -10px rgba(3, 90, 166, 0.4);\n}\n\n.ps-stat-pill b {\n    font-size: 18px;\n    font-weight: 800;\n}\n\n.ps-stat-pill span {\n    font-size: 12px;\n    color: #cfe4fb;\n}\n\n.ps-stat-pill.alt {\n    background: #fff;\n    border: 1px solid var(--border);\n}\n\n.ps-stat-pill.alt b {\n    color: var(--primary-700);\n}\n\n.ps-stat-pill.alt span {\n    color: var(--muted);\n}\n\n/* ---------- Inventory grid ---------- */\n\n.ps-inventory-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 14px;\n}\n\n.ps-inventory-card {\n    background: #fff;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    padding: 20px 16px;\n    transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.ps-inventory-card:hover {\n    border-color: var(--primary-500);\n    transform: translateY(-4px);\n    box-shadow: 0 14px 28px -14px rgba(0, 119, 214, 0.3);\n}\n\n.ps-inventory-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    background: var(--primary-50);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 14px;\n}\n\n.ps-inventory-icon img {\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n}\n\n.ps-inventory-card h4 {\n    font-size: 14px;\n    font-weight: 700;\n    margin: 0 0 6px;\n    color: #042a48;\n}\n\n.ps-inventory-card p {\n    font-size: 12px;\n    color: var(--muted);\n    margin: 0;\n}\n\n/* ---------- Section heads ---------- */\n\n.ps-sec-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 32px;\n    margin-bottom: 28px;\n    flex-wrap: wrap;\n}\n\n.ps-sec-tag {\n    display: block;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--primary-500);\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n}\n\n.ps-sec-head h2 {\n    font-size: 24px;\n    font-weight: 800;\n    letter-spacing: -0.01em;\n    max-width: 520px;\n    margin: 0;\n    color: #042a48;\n}\n\n.ps-sec-desc {\n    font-size: 13px;\n    color: var(--muted);\n    max-width: 420px;\n    margin: 0;\n}\n\n.ps-kpi-tag {\n    margin-bottom: 12px;\n}\n\n/* ---------- Two-column layout ---------- */\n\n.ps-cols {\n    display: flex;\n    gap: 40px;\n    align-items: flex-start;\n}\n\n.ps-cols > * {\n    flex: 1;\n    min-width: 0;\n}\n\n/* ---------- Platform badges ---------- */\n\n.ps-badge-row,\n.ps-logo-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.ps-badge {\n    font-size: 12.5px;\n    font-weight: 600;\n    color: var(--primary-700);\n    background: var(--primary-50);\n    border-radius: 8px;\n    padding: 9px 14px;\n    border: 1px solid transparent;\n    transition: transform 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.ps-badge:hover {\n    transform: translateY(-2px);\n    background: var(--primary-500);\n    color: #fff;\n    box-shadow: 0 10px 18px -8px rgba(0, 119, 214, 0.45);\n}\n\n.ps-badge.outline {\n    background: transparent;\n    border-color: var(--border);\n    color: var(--muted);\n}\n\n.ps-badge.outline:hover {\n    background: var(--primary-700);\n    border-color: var(--primary-700);\n    color: #fff;\n}\n\n/* ---------- KPI cards ---------- */\n\n.ps-kpi-grid {\n    display: flex;\n    gap: 12px;\n}\n\n.ps-kpi-card {\n    flex: 1;\n    min-width: 0;\n    border-radius: 12px;\n    padding: 20px 18px;\n    color: #fff;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.ps-kpi-card.c1 { background: var(--primary-700); }\n.ps-kpi-card.c2 { background: var(--primary-500); }\n.ps-kpi-card.c3 { background: #042a48; }\n\n.ps-kpi-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 16px 30px -12px rgba(3, 90, 166, 0.45);\n}\n\n.ps-kpi-card b {\n    font-size: 26px;\n    font-weight: 800;\n    display: block;\n}\n\n.ps-kpi-card span {\n    font-size: 12px;\n    font-weight: 700;\n    display: block;\n    margin: 4px 0 4px;\n}\n\n.ps-kpi-card p {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.75);\n    margin: 0;\n    line-height: 1.4;\n}\n\n/* ---------- Identity spine diagram ---------- */\n\n.ps-spine-wrap {\n    position: relative;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    background: #fff;\n    padding: 40px 24px;\n}\n\n.ps-spine-track {\n    position: absolute;\n    left: 5%;\n    right: 5%;\n    top: 50%;\n    height: 2px;\n    background: repeating-linear-gradient(90deg, var(--border) 0 8px, transparent 8px 14px);\n    transform: translateY(-50%);\n    z-index: 0;\n}\n\n.ps-node-row {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    z-index: 1;\n    flex-wrap: wrap;\n    gap: 18px 0;\n}\n\n.ps-node {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    width: 13.5%;\n    min-width: 100px;\n}\n\n.ps-node-dot {\n    width: 54px;\n    height: 54px;\n    border-radius: 50%;\n    background: #fff;\n    border: 2px solid var(--primary-500);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 0 0 6px #fff;\n    padding: 8px;\n    box-sizing: border-box;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.ps-node:hover .ps-node-dot {\n    transform: scale(1.12);\n    box-shadow: 0 0 0 6px #fff, 0 12px 22px -8px rgba(0, 119, 214, 0.5);\n}\n\n.ps-node-dot img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n}\n\n.ps-node span {\n    font-size: 12px;\n    font-weight: 700;\n    text-align: center;\n    color: #042a48;\n}\n\n/* ---------- Contextual targeting trio ---------- */\n\n.ps-trio {\n    display: flex;\n    gap: 14px;\n    margin-bottom: 28px;\n}\n\n.ps-trio-card {\n    flex: 1;\n    min-width: 0;\n    background: var(--primary-700);\n    border-radius: 12px;\n    padding: 22px 20px;\n    color: #fff;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.ps-trio-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 16px 30px -12px rgba(3, 90, 166, 0.45);\n}\n\n.ps-trio-card h4 {\n    font-size: 14.5px;\n    font-weight: 700;\n    margin: 0 0 8px;\n}\n\n.ps-trio-card p {\n    font-size: 12px;\n    color: #cfe4fb;\n    line-height: 1.5;\n    margin: 0;\n}\n\n/* ---------- Partner panel with logo chips ---------- */\n\n.ps-partner-panel {\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    padding: 22px;\n    background: #fff;\n    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.ps-partner-panel:hover {\n    transform: translateY(-3px);\n    border-color: var(--primary-500);\n    box-shadow: 0 14px 28px -14px rgba(0, 119, 214, 0.25);\n}\n\n.ps-logo-chip {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 40px;\n    padding: 6px 14px;\n    border: 1px solid var(--border);\n    border-radius: 8px;\n    background: #fff;\n}\n\n.ps-logo-chip img {\n    max-height: 100%;\n    max-width: 100px;\n    object-fit: contain;\n}\n\n/* ---------- Precision / safety list ---------- */\n\n.ps-prec-list {\n    display: flex;\n    flex-direction: column;\n}\n\n.ps-prec-item {\n    display: flex;\n    gap: 16px;\n    padding: 16px 12px;\n    border-bottom: 1px solid var(--border);\n    border-radius: 8px;\n    margin: 0 -12px;\n    transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;\n}\n\n.ps-prec-item:last-child {\n    border-bottom: none;\n}\n\n.ps-prec-item:hover {\n    transform: translateX(4px);\n    background: var(--primary-50);\n}\n\n.ps-prec-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 9px;\n    background: var(--primary-50);\n    flex: 0 0 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--primary-500);\n    font-size: 15px;\n    transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;\n}\n\n.ps-prec-item:hover .ps-prec-icon {\n    background: var(--primary-500);\n    color: #fff;\n    transform: scale(1.08);\n}\n\n.ps-prec-item h4 {\n    font-size: 14px;\n    font-weight: 700;\n    margin: 0 0 3px;\n    color: #042a48;\n}\n\n.ps-prec-item p {\n    font-size: 12.5px;\n    color: var(--muted);\n    margin: 0;\n}\n\n@media (max-width: 980px) {\n    .ps-inventory-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .ps-cols {\n        flex-direction: column;\n    }\n\n    .ps-kpi-grid {\n        flex-direction: column;\n    }\n\n    .ps-trio {\n        flex-direction: column;\n    }\n\n    .ps-node-row {\n        justify-content: center;\n    }\n\n    .ps-node {\n        width: 40%;\n    }\n\n    .ps-spine-track {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
